import React, { useEffect, useState } from "react";
import CountUp from "react-countup";

import GetElectricTransaction from "functions/chart/getElectricTransaction";
import moneyFormat from "functions/utils/moneyFormat";
import { bg_button } from "constant/css";
import { getMerchantId } from "service/storage";

const ElectricTransaction = () => {
  const merchantId = getMerchantId();
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    const response = await GetElectricTransaction(merchantId);
    setData(response);
  };

  return (
    <div
      className={`w-full max-w-6xl mx-auto p-4 ${bg_button} mt-6 bg-white shadow-xl rounded-2xl`}
    >
      {/* Header with gradient background */}
      <div className="text-white p-4 rounded-t-2xl  flex items-center gap-3">
        <div className="text-2xl">💡</div>
        <h2 className="text-2xl font-bold text-gray-200 tracking-wide">
          Тог гүйлгээ
        </h2>
      </div>

      {data ? (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-6 rounded-2xl shadow-sm">
          <div className="rounded-xl bg-white/50 p-4 text-center backdrop-blur-sm break-words group">
            <p className="text-sm text-gray-600">Нийт гүйлгээ</p>
            <div
              className="text-2xl font-bold text-gray-100 mt-1 max-w-full truncate group-hover:overflow-visible group-hover:whitespace-normal"
              title={data.totalCount}
            >
              {data.totalCount}
            </div>
          </div>

          <div className="rounded-xl bg-white/50 p-4 text-center backdrop-blur-sm break-words group">
            <p className="text-sm text-gray-600">Үүссэн дүн</p>
            <div
              className="text-2xl font-bold text-gray-100 mt-1 max-w-full truncate group-hover:overflow-visible group-hover:whitespace-normal"
              title={`${moneyFormat(data.created.totalAmount)} ₮`}
            >
              {moneyFormat(data.created.totalAmount)} ₮
            </div>
          </div>

          <div className="rounded-xl bg-white/50 p-4 text-center backdrop-blur-sm break-words group">
            <p className="text-sm text-gray-600">Төлөгдсөн дүн</p>
            <div
              className="text-2xl font-bold text-gray-100 mt-1 max-w-full truncate group-hover:overflow-visible group-hover:whitespace-normal"
              title={`${moneyFormat(data.paid.totalAmount)} ₮`}
            >
              {moneyFormat(data.paid.totalAmount)} ₮
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center text-gray-400">Уншиж байна...</div>
      )}
    </div>
  );
};

export default ElectricTransaction;
